export class Init {
    load(name: string, data: string[]) {
        if (name && localStorage.getItem(name) === null || localStorage.getItem(name) === undefined) {
            console.log('No data Found... Creating...');
            localStorage.setItem(name, JSON.stringify(data));
            return;
        } else {
            console.log('Found data...');
        }
    }
}
